import { useMemo } from 'react';
import { User } from './User';

export function useUserRole(user) {
  return useMemo(() => {
    return User.getRole(user);
  }, [user]);
}
